/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

class RemountManager {
  constructor() {
    this.isUnmounting = false;
    this.unmountPromise = null;
    this.unmountPromiseResolve = null;
    this.unmountPromiseReject = null;
  }

  setUnmountPromise = () => {
    this.unmountPromise = new Promise((resolve, reject) => {
      this.unmountPromiseResolve = resolve;
      this.unmountPromiseReject = reject;
    });
  };

  setIsUnmounting = unMountingPromise => {
    this.isUnmounting = true;
    unMountingPromise
      .then(() => {
        this.unmountPromiseResolve();
        this.isUnmounting = false;
      })
      .catch(() => {
        this.unmountPromiseReject();
      });
  };
  waitForUnmount = () => this.unmountPromise;
}

export default new RemountManager();
